import React, { useState } from 'react';
import { Mail, X } from 'lucide-react';
import useLang from '../../hooks/useLang';

const translations = {
  es: {
    question: '¿Quieres que Joaquín te llame?',
    subtext: 'Te contacta en menos de 24h. Sin compromiso.',
    close: 'Cerrar',
    placeholder: 'tu@email.es',
    submit: 'Enviar',
    sending: '…',
    gdpr: 'Al enviar aceptas nuestra Política de Privacidad.'
  },
  en: {
    question: 'Want Joaquín to call you?',
    subtext: 'Get contacted within 24h. No obligation.',
    close: 'Close',
    placeholder: 'your@email.com',
    submit: 'Send',
    sending: '…',
    gdpr: 'By sending you accept our Privacy Policy.'
  }
};

export const ChatLeadCapture = ({ onSubmit, onClose, submitting, error }) => {
  const lang = useLang();
  const t = translations[lang];
  const [email, setEmail] = useState('');
  const [hp, setHp] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(email, { website: hp });
  };

  return (
    <div
      className="mt-2 p-3.5 rounded-xl border-2 border-[#D4AF37] bg-gradient-to-br from-[#1B2A4A] to-[#2a3b66] text-white"
      data-testid="chat-lead-card"
    >
      <div className="flex items-start gap-2 mb-2">
        <Mail className="w-4 h-4 text-[#D4AF37] mt-0.5 flex-shrink-0" />
        <div className="text-xs leading-snug">
          <p className="font-semibold mb-0.5">{t.question}</p>
          <p className="text-white/75">{t.subtext}</p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="text-white/50 hover:text-white"
          aria-label={t.close}
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
      <form onSubmit={handleSubmit} className="flex gap-2">
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: '-10000px',
            top: 'auto',
            width: '1px',
            height: '1px',
            overflow: 'hidden',
          }}
        >
          <label htmlFor="chat-lead-hp">No rellenar</label>
          <input
            id="chat-lead-hp"
            name="website"
            type="text"
            tabIndex={-1}
            autoComplete="off"
            value={hp}
            onChange={(e) => setHp(e.target.value)}
          />
        </div>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t.placeholder}
          required
          disabled={submitting}
          data-testid="chat-lead-email"
          className="flex-1 px-2.5 py-1.5 rounded-md text-xs text-[#0f172a] bg-white border border-white/30 focus:outline-none focus:border-[#D4AF37]"
        />
        <button
          type="submit"
          disabled={submitting}
          data-testid="chat-lead-submit"
          className="px-3 py-1.5 rounded-md bg-[#D4AF37] hover:bg-[#b89426] text-[#1B2A4A] font-semibold text-xs disabled:opacity-50"
        >
          {submitting ? t.sending : t.submit}
        </button>
      </form>
      {error && <p className="text-[10px] text-red-200 mt-1.5">{error}</p>}
      <p className="text-[10px] text-white/60 mt-1.5">
        {t.gdpr}
      </p>
    </div>
  );
};

export default ChatLeadCapture;
